import { AiToolset } from 'actions';

const earningsAnnouncementsContext = [
  {
    role: 'system',
    content: `
    A simple chatbot for an investor to \
    find out when the next earnings announcement \
    is for a publicly listed company. \
    First, ask the investor which one company they would \
    like to find information for. Do not ask "how may I assist you", introduce yourself and your capabilities and go straight to the company question\
    Always assume that the investor is asking information \
    for the next quarter. \
    Get straight to the answer for the investors. Do not say \
    Great Choice. \
    Ask if there is another company they would like information for.
    If at any moment the user decides to go off-topic or ask anything unrelated to earnings announcements, say "Sorry, it is outside of my job function.".
      `,
  },
];

const etfScreenerContext = [
  {
    role: 'system',
    content: `
    You are an ETF Screener, an automated screening tool that lists ETFs for Canadian-based investors which accurately match the criteria they provide. \
Start by asking what asset class the user is interested in, such as equity, fixed income, asset allocation, or alternative.\
If the user chooses equity ask what other filters they would like to screen by, some examples are sector, size, style.\
If the user chooses asset allocation, ask for what risk profile.\
If the user chooses bond, ask what type, such as government or corporate, long or short term.\
If the user chooses alternative, ask what type.\
Then, ask them what investment region they are looking for, and give examples such as domestic, US, global, emerging, or developed. \
If the user is unsure of their filters, guide them with basic questions to determine their screening criteria. \
After you have collected all their filters, immediately return a list of up to 4 ETFs that most closely match the screening criteria, \
No more than 4 suggestions and only include the ones that match all the criteria exactly\
For each ETF in the response, provide the ticker symbol, fund name, fund provider, stock exchange where it is traded and a brief description, so the investor can make an informed investment decision. \
*If you cannot find at least one closely matched ETF do not make them up, \
instead say, “I’m sorry I could not identify any ETFs that match the current criteria. Let’s adjust your filters and try again.“*, \
Do not ever answer questions or queries outside the scope of finding matched ETFs, \
If the investor asks you out-of-scope questions say, \
“I’m sorry, I cannot answer that. I am programmed only to find ETFs. Is there anything else I can help you with regarding ETFs?“, \
Do not provide specific metrics or data points in your responses.
`,
  },
];

const initialState = {
  messages: [],
  currentContext: etfScreenerContext,
  taskID: '',
  error: '',
  pollingStatus: 'idle', // 'idle', 'polling', 'completed', 'error', 'timeout'
  loading: false,
  summaries: {},
};

export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case AiToolset.SEND_MESSAGE:
      return {
        ...state,
        currentContext: state.currentContext.concat({
          role: 'user',
          content: action.message,
        }),
        messages: state.messages.concat({
          role: 'user',
          content: action.message,
        }),
      };
    case AiToolset.RECEIVE_MESSAGE:
      return {
        ...state,
        currentContext: state.currentContext.concat({
          role: 'assistant',
          content: action.message,
        }),
        messages: state.messages.concat({
          role: 'assistant',
          content: action.message,
        }),
      };
    case AiToolset.SET_CONTEXT:
      // eslint-disable-next-line no-case-declarations
      let newContext;
      if (action.context === 'earningsAnnouncementsContext') {
        newContext = earningsAnnouncementsContext;
      } else if (action.context === 'etfScreenerContext') {
        newContext = etfScreenerContext;
      }
      return {
        ...state,
        currentContext: newContext,
        messages: [], // Clear previous messages
      };

    case AiToolset.SEND_STATEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };

    case AiToolset.SEND_STATEMENT_SUCCESS:
      return {
        ...state,
        taskID: action.taskID,
      };
    case AiToolset.SEND_STATEMENT_ERROR:
      return {
        ...state,
        error: action.fileSendError,
        loading: false,
      };
    case AiToolset.SEND_STATEMENT_ERROR_503:
      return {
        ...state,
        pdfDown: true,
        loading: false,
      };
    case AiToolset.TASK_STATUS_REQUEST:
      return {
        ...state,
        pollingStatus: 'polling',
        loading: true,
        error: '',
      };
    case AiToolset.TASK_STATUS_SUCCESS:
      return {
        ...state,
        pollingStatus: 'completed',
        taskResult: action.result,
        loading: false,
        error: '',
      };
    case AiToolset.TASK_STATUS_ERROR:
      return {
        ...state,
        pollingStatus: 'error',
        error: action.error,
        loading: false,
      };
    case AiToolset.TASK_STATUS_TIMEOUT:
      return {
        ...state,
        pollingStatus: 'timeout',
        error: action.error,
        loading: false,
      };
    case AiToolset.CLEAR:
      return initialState;

    case AiToolset.ANALYZE_SCORECARD:
      return {
        ...state,
        loading: true,
      };

    case AiToolset.ADD_SUMMARY_ITEM:
      return {
        ...state,
        loading: false,
        summaries: {
          ...state.summaries,
          [action.id]: action.value,
        },
      };
    case AiToolset.REMOVE_SUMMARY_ITEM: {
      const { [action.id]: removed, ...restSummaries } = state.summaries;
      return {
        ...state,
        summaries: restSummaries,
      };
    }

    default:
      return state;
  }
}
